import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				image: "play",
				play: "play",
			},
		};
	}

	init() {}

	play() {
		this.el.classList.add("is-init");

		this.$video = this.el.querySelector("[data-module-video]");

		if (this.$video) {
			this.videoId = this.$video.getAttribute("data-module-video");
			this.call("play", {}, "video", this.videoId);
		}
	}

	destroy() {}
}
